import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, of } from 'rxjs';
import { GlobalModalComponent } from './global-modal.component';

@Injectable({
  providedIn: 'root',
})
export class GlobalModalService {
  constructor(private dialog: MatDialog, private snackBar: MatSnackBar) {}

  confirm(title: string, message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(GlobalModalComponent, {
      width: '450px',
      panelClass: 'cyber-modal-panel',
      data: { title, message, type: 'confirm' },
    });

    return dialogRef.afterClosed();
  }

  // EVOLUCIÓN UX: Movido a Top-Center con mayor prominencia visual
  showSuccess(title: string, message: string): Observable<void> {
    this.snackBar.open(`[✔] ${title.toUpperCase()}: ${message}`, 'OK', {
      duration: 4000,
      horizontalPosition: 'center', // Centrado en la pantalla
      verticalPosition: 'top',      // Arriba
      panelClass: ['cyber-toast', 'success-toast']
    });
    
    return of(undefined);
  }

  showError(title: string, message: string): void {
    this.dialog.open(GlobalModalComponent, {
      width: '450px',
      panelClass: 'cyber-modal-panel',
      data: { title, message, type: 'error' },
    });
  }
}